import { IntelligenceSearchProvider } from "@src/contexts/intelligence-search/intelligence-search-context";
import { Checkbox, Form, Popover } from "antd";
import { ProductInput } from "./component/product-input";
import { PlatformInput } from "./component/platform-input";
import { TimeRangeInput } from "./component/time-range";
import { SearchComponent } from "./component/search-component";
import { ChartWrapperContextProvider } from "@src/contexts/ab-testing/chart-wrapper-context";
import { IJobMeta } from "@src/types/ab-testing-exploration";
import { css } from "@emotion/react";
import { IntelligenceFormFieldsEnum } from "./enum";
import { SmlAsset } from "@src/types/intelligence-search";
import { FormInstance } from "antd/lib";
import satGuidelineImage from "@src/assets/images/SAT-Guideline-IS.jpg";
import { BulbTwoTone } from "@ant-design/icons";
import { useWatchFormWithInit } from "@src/hooks/form/use-watch-form-with-init";
import { useMemo } from "react";
import { PERMISSION_LAYOUT_CHECK } from "@src/components/crud-permission-layout";
import { TooltipPlacement } from "antd/es/tooltip";

export type SearchResultType = {
    data: Record<string, any>[];
    query: string;
    meta: IJobMeta;
    cache_hit: boolean;
    schema: any[];
    ref_assets: SmlAsset[];
};
export const IntelligenceSearchList: React.FC<{ form: FormInstance<any>; isCreate?: boolean }> = ({
    form,
    isCreate = false,
}) => {
    return (
        <IntelligenceSearchProvider assetsMeta={[]} form={form}>
            <ChartWrapperContextProvider>
                <div className="w-full ">
                    <div
                        css={css`
                            .ant-form-item {
                                margin-bottom: 0 !important;
                            }
                        `}
                        className=""
                    >
                        <div
                            css={css`
                                > *:not(:last-child) {
                                    margin-right: 20px;
                                }
                            `}
                            className={`${PERMISSION_LAYOUT_CHECK}  flex justify-start items-center flex-wrap`}
                        >
                            <ProductInput form={form} isCreate={isCreate} />
                            <PlatformInput form={form} />
                            <TimeRangeInput form={form} />
                        </div>
                        <div className="flex space-x-2 py-2 ">
                            <UseHint form={form} />
                        </div>
                    </div>
                    <Form.Item
                        name={IntelligenceFormFieldsEnum.IS_INIT_FORM_WITH_PARAMS}
                        hidden
                        valuePropName="checked"
                    >
                        <Checkbox />
                    </Form.Item>
                    <Form.Item name={IntelligenceFormFieldsEnum.IS_CUSTOM_TITLE} hidden valuePropName="checked">
                        <Checkbox />
                    </Form.Item>
                    <SearchComponent form={form} />
                </div>
            </ChartWrapperContextProvider>
        </IntelligenceSearchProvider>
    );
};

const UseHint: React.FC<{ form: FormInstance<any> }> = ({ form }) => {
    const productWatch = useWatchFormWithInit(IntelligenceFormFieldsEnum.PRODUCT_CODE, form);
    const platformWatch = useWatchFormWithInit(IntelligenceFormFieldsEnum.PLATFORM, form);
    const timeRangeWatch = useWatchFormWithInit(IntelligenceFormFieldsEnum.TIME_RANGE, form);
    const isEnoughRequireField = useMemo(() => {
        return productWatch && platformWatch && timeRangeWatch;
    }, [productWatch, platformWatch, timeRangeWatch]);
    return <UseHintContent isEnoughRequireField={isEnoughRequireField} />;
};

export const UseHintContent: React.FC<{ isEnoughRequireField: boolean; placement?: TooltipPlacement }> = ({
    isEnoughRequireField,
    placement = "right",
}) => {
    if (!isEnoughRequireField) {
        return null;
    }
    return (
        <div>
            <span>How to use?</span>

            <Popover
                placement={placement}
                content={
                    <div className="w-full overflow-hidden">
                        <img className="w-[400px] object-cover" src={satGuidelineImage} alt="how to use" />
                    </div>
                }
            >
                <BulbTwoTone className="cursor-pointer mx-1" />
            </Popover>
        </div>
    );
};
